import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/utils/flexible.js";
import VueI18n from "vue-i18n";

Vue.use(ElementUI);
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh", //使用localStorage缓存到本地localStorage.getItem('language') ||，当下次使用时可默认当前使用语言
  messages: {
    zh: require("./common/lang/zh"),
    en: require("./common/lang/en"),
  },
});
Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
